function Loading() {
  
  return (
    <div className="section">
      <div className="container">
        <div className="columns">
          <div className="column is-6 is-offset-3">
            <div className="loader-wrapper is-active">
              <div className="loader is-loading"></div>
            </div> 
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loading